import { type FunctionComponent, type ReactNode, useCallback } from 'react';
import { ErrorBoundary, type ErrorBoundaryProps } from 'react-error-boundary';
import { ErrorDetect } from '../../components/ErrorDetect/ErrorDetect';
import { useContainer } from '../../hooks/useContainer';
import { ErrorRecoveryPage } from '../../pages/ErrorRecoveryPage/ErrorRecoveryPage';
import { CcmCustomAttribute, LoggerService } from '../../services/logger';

export type ErrorBoundaryProviderProps = {
  boundaryName: string;
  children?: ReactNode;
};

export const ErrorBoundaryProvider: FunctionComponent<
  ErrorBoundaryProviderProps
> = ({ boundaryName, children }) => {
  const logger = useContainer().get(LoggerService);

  const renderErrorFallback = useCallback<
    Required<ErrorBoundaryProps>['fallbackRender']
  >(
    ({ error }) => {
      logger.error(error, {
        [CcmCustomAttribute.ERROR_BOUNDARY]: boundaryName,
        [CcmCustomAttribute.ERROR_ROUTE]: globalThis.location.pathname,
      });
      return <ErrorRecoveryPage />;
    },
    [boundaryName, logger],
  );

  return (
    <ErrorBoundary fallbackRender={renderErrorFallback}>
      <ErrorDetect />
      {children}
    </ErrorBoundary>
  );
};
